import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    chatLoadingContainer: {
      minWidth: '340px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
    chatLoading: {
      display: 'flex',
    },
  });
};
